var _defs, _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-13.9%",
    width: "138.9%",
    height: "138.9%",
    filterUnits: "objectBoundingBox",
    id: "shopping_cart_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.822463768 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "shopping_cart_svg__b",
    d: "M125 5h36v36h-36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-122 -3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#shopping_cart_svg__a)",
    xlinkHref: "#shopping_cart_svg__b"
  }), /*#__PURE__*/React.createElement("image", {
    x: 125,
    y: 5,
    width: 36,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAA0mlDQ1BJQ0MgUHJvZmlsZQAAGJVjYGCsSCwoyGESYGDIzSspcg9yjIyIjFJgv8rAzsDIAAaJycUFjgEBPgw4wbdrELWXdUFm4VaHFbCkpBYnA+ktQFyaXFBUwsDAqANkq5eXFIDYIUC2SHZIkDOQnQFk80HVg4C0c2JOZlJRYklqioJ7UWKlgnN+Tn5RcUFiciqJriAClKRWlIBo5/yCyqLM9IwSBUegb1OBduYWlJakFukoeOYl6zEwgMIPouNzIDhcGMXOJJcWlUGNYWQyZmAAABFdNMUdedORAAAETklEQVRoBe1ZbYhVRRh+ZrXMz1YxpcQ010pBDUIRgpYIiT6IojCMQPxREBVUrIk/9V8g+GdFDCr6E/UjoqAEQVBksYzUlcKPdNtdF1vNTRfv5m6m9/E9c2bOOXP3HOdc7/HeP3eG3Xm/Zt7nvO/cOWdmAClcyCM8zW1cFHANKNzJsNzgD3yWqu4Q+IEBEDZ/CH9vnUHwffY7IEa4i8vrCoIT+DL3OiDIPWytKwiZjku5g1cSMDbWGUDgjtP5Hk8YEB83AIAG0VovAC0NesLIbRNAwyOQsezK7/+yTtMldKNH1zPoUaUodYURPgCuo4sQGBGcv13l7XHVAXB9jAiUGNCAKrvqfJwPQA9GsQhTcgx2DX0JOL3qvxx9xMQHYKvaImvj/WjDYvkL6mLMyjF0GeeS8VFXsvpMzFIk5WoQg+iyEpmgIZAQ0LzUh2jBfKlPRX2GHDgXrBzIBSA2Dyg1jMNSTeE9kiIbmzYsxF1W47SzMRurrYT/CpxubFIC5DYA2GHCVo3huFRTOEGe2yYrgDXNapx2KlZIVVhfAABnYKgbMhX7sNdKOddJ131WrtsHg/81R8AZchwjQb6Ag1bMGSZZHYig3GEA1nXYym/hqFTw9RhAw98FTQDNCDQj0IxAMwKNjACDN4QPwAL3dVIQp1/E6M0DYA2nFuQ0GobtmKmZXyLReIJ2d0x+zTzfxOOHyJDwYfaYnfeywMT3VRzY9OF7nILOWMDWUCbhcazFZD3Cp+qtoM0DoAaPmV37sTzc6PkmYeYINSn2od3uM32fZJ9jGOvwQE3ukp2HcATfYZeKEuoDMCA7ow5OxpysZCVH99Jj6nyljQ+Atlej6K/sWBTfmDmQQJ8FIMpRwvaOkFkAShjR/oqbftXCZ5der85wUrU9q7PPigDMdrwNncw1UatzG1tnrISyfZopy2+4g+vGN/iz5qW4jNP4Xf0fu/ZSfMO8NIprxuQ8/lGv49iAr7JUnHcz0lW+G3vwUlzCTp4rHMSLsePMORCbyKnHWfM2+A2dMjMeQwcWaP0xvB3bpVCb8ZKWlrAdBzAXG/CM5s9jmfonxT5dxBdMBHbTnP9wGo9qWZlL0vsEUk7hJW01zDZrJTdzYfnQSnK03G46zY+N+aSRvRPLKik+YWw+ijW8m4Na+pWVZa8D1gJy6BSUs2ogFuEQrmvuoYSskrS6rlihriH8ElxlZXkADGnjVuc+cbo5XbpoB0pprc492Ay5YWufB8Cv2ngGnredpF1n6FCXUCRIq7O2opLZsFJbHErY+UiuMLn8i+aokc+Z9eHqrS84edz03BhGT66IDxvJaz6vjp6fmG7XuZ+f8SfDkZ65zKdZNrYn+QV/5Ijh9jvpdHylMnKR1xs5jYkD9CZQbiHHlxLt9Ez1lirkHH7rjFSWFTLHnokt7OCo0/MgH0l14RfyFQn/MblX/Vmeq91vby1kOd/GfbzMU/ySb1ZG7SYmeE7YeZHJkwAAAABJRU5ErkJggg=="
  }))));
};

export { SvgShoppingCart as ReactComponent };
export default "/_next/static/media/shopping_cart.6be649df.svg";